// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Restaumatic_I18n_TranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
var translationPending_ = function (defaultTranslation) {
    return defaultTranslation;
};
var translationPending = function () {
    return function () {
        return Data_Function_Uncurried.runFn2($foreign["_interpolate"]);
    };
};
var translateIn = function (locale) {
    return function (key) {
        return function (values) {
            return $foreign["_translateIn"](Restaumatic_Locales.toText(locale), Restaumatic_I18n_TranslationKeys.unTranslationKey(key), values);
        };
    };
};
var translateIn_ = function (locale) {
    return function (key) {
        return translateIn(locale)(key)({});
    };
};
var translate = function (key) {
    return function (values) {
        return $foreign["_translate"](Restaumatic_I18n_TranslationKeys.unTranslationKey(key), values);
    };
};
var translate_ = function (key) {
    return translate(key)({});
};
var setGlobalLocale = function (locale) {
    return function () {
        return $foreign["_setGlobalLocale"](Restaumatic_Locales.toText(locale));
    };
};
var isStringRecordNil = {};
var isStringRecordCons = function () {
    return {};
};
var defaultLocale = /* #__PURE__ */ (function () {
    return Restaumatic_Locales.EN.value;
})();
var getGlobalDefaultLocale = function __do() {
    var str = $foreign["_getGlobalDefaultLocale"]();
    var v = Restaumatic_Locales.fromText(str);
    if (v instanceof Data_Maybe.Nothing) {
        Effect_Class_Console.log(Effect_Class.monadEffectEffect)("WARNING: Invalid global default locale: " + (Data_Show.show(Data_Show.showString)(str) + (". Defaulting to " + Data_Show.show(Restaumatic_Locales.showLocale)(defaultLocale))))();
        return defaultLocale;
    };
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.I18n (line 60, column 3 - line 65, column 18): " + [ v.constructor.name ]);
};
var getGlobalLocale = function (dictMonadEffect) {
    return Effect_Class.liftEffect(dictMonadEffect)(function __do() {
        var str = $foreign["_getGlobalLocale"]();
        var v = Restaumatic_Locales.fromText(str);
        if (v instanceof Data_Maybe.Nothing) {
            Effect_Class_Console.log(Effect_Class.monadEffectEffect)("WARNING: Invalid global locale: " + (Data_Show.show(Data_Show.showString)(str) + (". Defaulting to " + Data_Show.show(Restaumatic_Locales.showLocale)(defaultLocale))))();
            return defaultLocale;
        };
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        throw new Error("Failed pattern match at Restaumatic.I18n (line 49, column 3 - line 54, column 18): " + [ v.constructor.name ]);
    });
};
export {
    translate,
    translate_,
    translateIn,
    translateIn_,
    getGlobalLocale,
    setGlobalLocale,
    getGlobalDefaultLocale,
    translationPending_,
    translationPending,
    isStringRecordNil,
    isStringRecordCons
};
export {
    makeTranslationKey,
    unTranslationKey,
    unsafeMakeTranslationKeysProxy
} from "../Restaumatic.I18n.TranslationKeys/index.js";
//# sourceMappingURL=index.js.map
